import { FC, useEffect, useState } from "react";
import clsx from "clsx";
import { toHHMMSS } from "@ht/shared/methods";
import moment from "moment";

interface IProps {
    checkState: {
        chatConnected?: boolean;
        chatServerConnected?: boolean;
        vcallConnected?: boolean;
        sipConnected?: boolean;
        callpresence?: string;
    };
    durationFrom: number;
}
const PresenceSwitch: FC<IProps> = ({ checkState, durationFrom }) => {
    const [duration, setDuration] = useState(0);
    const [tmrDuration, setTmrDuration] = useState(0);
    const { chatConnected, vcallConnected, sipConnected, callpresence } = checkState;
    const flaglabel = (connectedflag: number, maxflag: number) => {
        let flag = "Offline";
        if (connectedflag > 0) {
            if (connectedflag === maxflag) flag = "Online";
            else if (connectedflag < maxflag) flag = "Online*";
        }
        if (callpresence == "ACW") flag = "Offline";
        return flag;
    };
    const getFlag = () => {
        let maxflag = 0
        let connectedflag = 0
        if (chatConnected !== undefined) {
            maxflag++;
            if (chatConnected) connectedflag++
        }
        if (vcallConnected !== undefined) {
            maxflag++;
            if (vcallConnected) connectedflag++
        }
        if (sipConnected !== undefined) {
            maxflag++;
            if (sipConnected) connectedflag++
        }
        return flaglabel(connectedflag, maxflag);
    };

    const stopTimer = () => {
        clearInterval(tmrDuration);
    };
    const startTimer = () => {
        const tmr = window.setInterval(() => {
            const now = moment.utc();
            const dur = Math.floor(
                moment.duration(now.diff(moment.unix(durationFrom))).asSeconds()
            );
            setDuration(dur);
        }, 1000);
        setTmrDuration(tmr);
    };
    useEffect(() => {
        stopTimer();
        startTimer();
    }, [durationFrom]);

    return (
        <div className="flex flex-row gap-[6px] items-center">
           <div
                className={clsx(
                    "w-[5px] h-[5px] rounded-full",
                    getFlag() == "Offline" ? "bg-danger" : "bg-success"
                )}
            ></div>

            <div className="text-base text-gray-900 font-semibold">{getFlag()}</div>
            <div className="text-base text-gray-400 font-semibold">{toHHMMSS(duration)}</div>
        </div>
    );
};

export default PresenceSwitch;
